import { render, staticRenderFns } from "./serviceTag.vue?vue&type=template&id=367f2b3b&scoped=true"
import script from "./serviceTag.vue?vue&type=script&lang=js"
export * from "./serviceTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367f2b3b",
  null
  
)

export default component.exports